module.exports = __webpack_public_path__ + "media/images/pc/stores/suns/how_to_enjoy_photography_case4-81ba74f80da97157dbb13d3f2811de15.jpg";